/* NYLA — Pinktober timers. Counts down every [data-pk-countdown] to its
   data-pk-end, and once the sale is over hides [data-pk-hide-on-end] and puts
   the normal prices back, even on a page that was cached before the end. */
(function () {
  'use strict';

  function endOf(el) {
    var t = Date.parse(el.getAttribute('data-pk-end') || '');
    return isNaN(t) ? null : t;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function put(box, sel, v) {
    var el = box.querySelector(sel);
    if (el && el.textContent !== v) { el.textContent = v; }
  }

  function tick() {
    var now = Date.now();
    var timers = document.querySelectorAll('[data-pk-countdown]');
    for (var i = 0; i < timers.length; i++) {
      var end = endOf(timers[i]);
      if (end === null) { continue; }
      var s = Math.max(0, Math.floor((end - now) / 1000));
      put(timers[i], '[data-pk-d]', pad(Math.floor(s / 86400)));
      put(timers[i], '[data-pk-h]', pad(Math.floor((s % 86400) / 3600)));
      put(timers[i], '[data-pk-m]', pad(Math.floor((s % 3600) / 60)));
      put(timers[i], '[data-pk-s]', pad(s % 60));
    }
    var hide = document.querySelectorAll('[data-pk-hide-on-end]');
    for (var j = 0; j < hide.length; j++) {
      var e = endOf(hide[j]);
      if (e !== null && now > e) { hide[j].hidden = true; }
    }
    var prices = document.querySelectorAll('[data-pk-price]');
    for (var k = 0; k < prices.length; k++) {
      var pe = endOf(prices[k]);
      if (pe !== null && now > pe) {
        var on = prices[k].querySelector('.pk-on');
        var off = prices[k].querySelector('.pk-off');
        if (on) { on.hidden = true; }
        if (off) { off.hidden = false; }
      }
    }
  }

  tick();
  setInterval(tick, 1000);
})();
